import React from "react"

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Capa_1"
    x="0px"
    y="0px"
    viewBox="0 0 511.999 511.999"
  >
    {" "}
    <g>
      {" "}
      <g>
        {" "}
        <path d="M443.441,223.633l-14.838-14.838c-10.172-10.173-26.723-10.171-36.895,0l-16.71,16.711l-7.867-7.866l13.84-13.84    c2.929-2.929,2.929-7.678,0-10.606L271.401,83.621c-2.93-2.929-7.678-2.929-10.607,0l-13.84,13.839l-7.867-7.867l16.711-16.711    c4.928-4.927,7.642-11.478,7.642-18.446s-2.714-13.519-7.641-18.446L240.96,21.15c-1.407-1.407-3.314-2.197-5.304-2.197    s-3.896,0.79-5.304,2.197L127.485,124.019c-2.929,2.929-2.929,7.678,0,10.606l14.838,14.838    c4.927,4.927,11.478,7.641,18.446,7.641s13.519-2.713,18.446-7.641l16.712-16.712l7.867,7.866l-13.842,13.842    c-1.406,1.406-2.196,3.314-2.196,5.303c0,1.989,0.79,3.897,2.196,5.303l11.64,11.64l-10.652,10.652    c-1.406,1.406-2.196,3.314-2.196,5.303c0,1.989,0.79,3.897,2.196,5.303l21.387,21.387L6.804,424.877    c-9.072,9.073-9.072,23.836,0,32.909c4.396,4.395,10.238,6.816,16.454,6.816s12.059-2.42,16.455-6.816l127.874-127.874    c2.929-2.929,2.929-7.678,0-10.606c-2.93-2.929-7.678-2.929-10.607,0L29.108,447.179c-1.563,1.563-3.64,2.423-5.849,2.423    s-4.285-0.86-5.847-2.422c-3.225-3.225-3.225-8.471,0-11.695L222.935,229.96l11.695,11.695l-53.835,53.834    c-2.929,2.929-2.929,7.678,0,10.606c1.465,1.465,3.384,2.197,5.304,2.197c1.919,0,3.839-0.732,5.304-2.197l53.834-53.834    l21.388,21.387c1.407,1.407,3.314,2.197,5.304,2.197s3.896-0.79,5.304-2.197l10.652-10.652l11.639,11.639    c1.465,1.464,3.385,2.197,5.304,2.197c1.92,0,3.839-0.732,5.304-2.197l13.84-13.841l7.868,7.867l-16.712,16.712    c-4.928,4.927-7.642,11.478-7.642,18.446c0,6.968,2.714,13.52,7.641,18.446l14.838,14.838c1.407,1.407,3.314,2.197,5.304,2.197    c1.99,0,3.896-0.79,5.304-2.197l28.356-28.357c2.929-2.929,2.929-7.678-0.001-10.606c-2.928-2.93-7.677-2.929-10.606,0    l-23.052,23.053l-9.535-9.535c-2.094-2.094-3.247-4.878-3.247-7.839s1.153-5.745,3.248-7.839l76.581-76.582    c4.321-4.321,11.355-4.323,15.679,0l9.535,9.535l-45.393,45.392c-2.929,2.929-2.929,7.678,0,10.606    c2.929,2.928,7.677,2.93,10.607,0l50.695-50.695c1.406-1.406,2.196-3.314,2.196-5.303    C445.638,226.947,444.847,225.039,443.441,223.633z M168.61,138.856c-2.095,2.094-4.879,3.248-7.84,3.248    c-2.962,0-5.745-1.153-7.839-3.247l-9.535-9.535l92.261-92.261l9.534,9.535c2.095,2.094,3.248,4.878,3.248,7.84    c0,2.962-1.153,5.745-3.248,7.839L168.61,138.856z M236.346,108.068l-21.943,21.943l-7.867-7.867l21.943-21.943L236.346,108.068z     M271.929,257.74l-65.077-65.077l5.349-5.349l65.077,65.077L271.929,257.74z M304.829,258.726l-98.964-98.962l23.13-23.13    l98.963,98.963L304.829,258.726z M239.601,126.027l5.732-5.732l3.015-3.015l98.963,98.963l-8.747,8.747L239.601,126.027z     M342.447,258.056l-7.867-7.867l21.943-21.943l7.867,7.866L342.447,258.056z M357.919,205.635l-98.963-98.963l7.141-7.141    l98.963,98.963L357.919,205.635z"></path>{" "}
      </g>{" "}
    </g>{" "}
    <g>
      {" "}
      <g>
        {" "}
        <path d="M504.5,450.892h-16.644v-15.053c0-4.142-3.357-7.5-7.5-7.5H295.159c-4.143,0-7.5,3.358-7.5,7.5v15.053h-16.644    c-4.143,0-7.5,3.358-7.5,7.5v27.154c0,4.142,3.357,7.5,7.5,7.5h31.141c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-23.641    v-12.153h218.484v12.153H335.835c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h168.664c4.143,0,7.5-3.358,7.5-7.5v-27.154    C512,454.25,508.642,450.892,504.5,450.892z M472.855,450.892H302.659v-7.553h170.196V450.892z"></path>{" "}
      </g>{" "}
    </g>{" "}
    <g>
      {" "}
      <g>
        {" "}
        <path d="M387.757,340.937c-4.143,0-7.5,3.358-7.5,7.5v22.472c0,4.142,3.357,7.5,7.5,7.5c4.143,0,7.5-3.358,7.5-7.5v-22.472    C395.257,344.295,391.9,340.937,387.757,340.937z"></path>{" "}
      </g>{" "}
    </g>{" "}
    <g>
      {" "}
      <g>
        {" "}
        <path d="M467.882,365.99c-2.93-2.929-7.678-2.929-10.607,0l-15.89,15.89c-2.93,2.929-2.93,7.678-0.001,10.606    c1.465,1.465,3.385,2.197,5.304,2.197s3.839-0.732,5.304-2.197l15.89-15.89C470.811,373.667,470.811,368.918,467.882,365.99z"></path>{" "}
      </g>{" "}
    </g>{" "}
    <g>
      {" "}
      <g>
        {" "}
        <path d="M334.132,381.88l-15.89-15.89c-2.929-2.929-7.677-2.93-10.607,0c-2.929,2.929-2.929,7.677,0,10.606l15.89,15.89    c1.464,1.465,3.383,2.197,5.303,2.197c1.919,0,3.839-0.732,5.304-2.197C337.061,389.557,337.061,384.809,334.132,381.88z"></path>{" "}
      </g>{" "}
    </g>{" "}
    <g>
      {" "}
      <g>
        {" "}
        <path d="M467.078,399.93c-4.143,0-7.5,3.358-7.5,7.5v0.198c0,4.142,3.357,7.5,7.5,7.5c4.143,0,7.5-3.358,7.5-7.5v-0.198    C474.578,403.288,471.221,399.93,467.078,399.93z"></path>{" "}
      </g>{" "}
    </g>{" "}
    <g>
      {" "}
      <g>
        {" "}
        <path d="M308.437,399.93c-4.143,0-7.5,3.358-7.5,7.5v0.198c0,4.142,3.357,7.5,7.5,7.5c4.143,0,7.5-3.358,7.5-7.5v-0.198    C315.937,403.288,312.58,399.93,308.437,399.93z"></path>{" "}
      </g>{" "}
    </g>{" "}
    <g>
      {" "}
      <g>
        {" "}
        <path d="M420.983,366.639c-4.143,0-7.5,3.358-7.5,7.5v0.198c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-0.198    C428.483,369.997,425.126,366.639,420.983,366.639z"></path>{" "}
      </g>{" "}
    </g>{" "}
    <g>
      {" "}
      <g>
        {" "}
        <path d="M354.532,366.639c-4.143,0-7.5,3.358-7.5,7.5v0.198c0,4.142,3.357,7.5,7.5,7.5c4.143,0,7.5-3.358,7.5-7.5v-0.198    C362.032,369.997,358.675,366.639,354.532,366.639z"></path>{" "}
      </g>{" "}
    </g>{" "}
    <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>{" "}
    <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>{" "}
  </svg>
)
